<div class="dialog-panel">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-header">
        <h1 class="dialog-title dot">{{ 'product.request_info' | transloco }}</h1>
      </div>
      <div class="dialog-body">
        <p class="info">
          {{ 'product.request_info_copy' | transloco }}
        </p>
        @for (key of order; track key) {
          <div class="form-field-container">
            <div class="form-field-label" [ngClass]="{ required: key !== 'message' }">
              {{ 'form.field.' + key | transloco }}
            </div>
            <mat-form-field class="form-field" [floatLabel]="'auto'">
              @if (key === 'message') {
                <textarea
                  matInput
                  [formControlName]="key"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="3"
                  cdkAutosizeMaxRows="6"
                  maxlength="500"
                ></textarea>
              } @else {
                <input matInput [formControlName]="key" required />
              }
              @if (getFormControl(key).invalid) {
                <mat-error>
                  @if (getFormControl(key).errors.email) {
                    {{ 'form.error.invalid_email' | transloco }}
                  }
                  @if (getFormControl(key).errors.required) {
                    {{ 'form.error.required' | transloco }}
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <div class="dialog-bottom">
        <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
          {{ 'global.send' | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
